import React from 'react';
import PropTypes from 'prop-types';
import { FiActivity, FiLoader } from 'react-icons/fi';
import { format, parseISO } from 'date-fns';
import { ptBR } from 'date-fns/locale/pt-BR';
import {
  HealthContainer,
  HealthHeader,
  HealthStatus,
  StatusDot,
  HealthBody,
  HealthMetric,
  LastUpdate,
  LoadingHealth,
  ErrorHealth
} from './SchedulerHealth.styles';

const SchedulerHealth = ({ health, isLoading, error }) => {
  if (isLoading) {
    return (
      <LoadingHealth>
        <FiLoader size={32} />
        <p>Verificando status do scheduler...</p>
      </LoadingHealth>
    );
  }

  if (error) {
    return (
      <ErrorHealth>
        <h3>⚠ Erro ao verificar status</h3>
        <p>{error}</p>
      </ErrorHealth>
    );
  }

  if (!health) return null;

  const isRunning = health.status === 'running';

  const formatTimestamp = (timestamp) => {
    if (!timestamp) return 'Não disponível';
    try {
      return format(parseISO(timestamp), "dd/MM/yyyy 'às' HH:mm:ss", { locale: ptBR });
    } catch (error) {
      return timestamp;
    }
  };

  return (
    <HealthContainer>
      <HealthHeader>
        <h3>
          <FiActivity size={20} />
          Status do Scheduler
        </h3>
        <HealthStatus>
          <StatusDot $isRunning={isRunning} />
          {isRunning ? 'Operacional' : 'Parado'}
        </HealthStatus>
      </HealthHeader>

      <HealthBody>
        <HealthMetric>
          <label>Total de Jobs</label>
          <span>{health.jobs_count || 0}</span>
        </HealthMetric>

        <HealthMetric>
          <label>Status</label>
          <span>{isRunning ? '✓ Executando' : '✗ Parado'}</span>
        </HealthMetric>
      </HealthBody>

      <LastUpdate>
        Última verificação: {formatTimestamp(health.timestamp)}
      </LastUpdate>
    </HealthContainer>
  );
};

SchedulerHealth.propTypes = {
  health: PropTypes.shape({
    status: PropTypes.string,
    jobs_count: PropTypes.number,
    timestamp: PropTypes.string,
  }),
  isLoading: PropTypes.bool,
  error: PropTypes.string,
};

SchedulerHealth.defaultProps = {
  health: null,
  isLoading: false,
  error: null,
};

export default SchedulerHealth;
